import Title from '@/components/Title';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';
import potentialImg1 from '@public/images/math/potential-list-1.png';
import potentialImg2 from '@public/images/math/potential-list-2.png';
import potentialImg3 from '@public/images/math/potential-list-3.png';
import potentialImg4CN from '@public/images/math/potential-list-4-cn.png';
import potentialImg4EN from '@public/images/math/potential-list-4-en.png';
import cls from 'classnames';
import LeadButton from '@/components/LeadButton';
import React from 'react';

const Potential = () => {
  const { t, i18n } = useTranslation(['home', 'math']);
  const btnName = (
    <span className="whitespace-nowrap bg-[linear-gradient(88.05deg,#256AF2_1.67%,#14A9FF_98.38%)] bg-clip-text text-transparent">
      {t('math:了解更多')}
    </span>
  );
  return (
    <div className="container mt-[80px] flex flex-col">
      <div className="relative mb-[60px] flex justify-center">
        <Title className="relative" innerHTML theme="math">
          {`${t('math:激发潜能-标题', { tag: '' })}
          <div class="absolute right-[-100px] top-[-45px] hidden h-[80px] w-[80px] shrink-0 items-center justify-center rounded-[20px] bg-[linear-gradient(135deg,rgba(255,255,255,0.56)_0%,#FFF_100%)] shadow-[0px_33px_50px_0px_rgba(0,0,0,0.06)] rotate-[-15deg] lg:flex xl:flex">
          <img class="w-[49px]" src="/images/english/thumb.png" alt="" />
        </div>`}
        </Title>
      </div>
      <div className="m-auto flex w-full flex-col gap-[24px] lg:gap-[80px] xl:gap-[80px]">
        <div className="flex flex-col lg:flex-row lg:gap-[40px] xl:flex-row xl:gap-[60px]">
          <div className="w-full rounded-[36px] lg:h-[286px] lg:w-[440px] xl:h-[364px] xl:w-[560px]">
            <Image
              width={0}
              height={0}
              sizes="100vw"
              className="h-auto w-full"
              src={potentialImg1}
              alt={
                i18n.language === 'zh'
                  ? '全球覆盖，全天候开课，双师模式，双倍信赖！'
                  : '24/7 global classes with dedicated teachers and time slots.'
              }
            />
          </div>
          <div className="mt-[-34px] flex flex-1  flex-col justify-center rounded-[24px] bg-[#fff] p-[24px] shadow-[0_8px_30px_0_rgba(0,0,0,0.06)] lg:mt-[0] lg:p-0 lg:shadow-[none] xl:mt-[0] xl:p-0 xl:shadow-[none]">
            <h3 className="mb-[16px] text-[20px] font-bold leading-[24px] text-wk-words-1 lg:mb-[12px] lg:text-[20px] lg:leading-[28px] xl:mb-[16px] xl:text-[28px] xl:leading-[40px]">
              {t('math:全天候开课')}
            </h3>
            <p
              className={cls(
                'mb-[16px] text-[16px] font-normal leading-[24px] text-wk-words-2 lg:mb-[20px] xl:mb-[40px] xl:text-[18px] xl:leading-[32px]',
                i18n?.language === 'zh' ? 'lg:leading-[28px]' : 'lg:leading-[22px]',
              )}
              dangerouslySetInnerHTML={{ __html: t('math:全天候开课-副') }}
            />
            <LeadButton
              subject="math"
              theme="mathBorder"
              size="base"
              className={cls(
                'm-auto h-[50px] w-[128px] text-[16px] !font-[500] lg:h-[46px] lg:w-[144px] lg:px-[40px] lg:py-[12px] xl:m-0 xl:h-[60px] xl:w-[200px] xl:px-[60px] xl:py-[16px] xl:!text-[20px]',
                i18n?.language === 'zh' ? 'w-[100px]' : 'w-[120px]',
              )}
              traceName="O_MathCourse_EachClass_GlobalCoverageCTAClick"
              traceGa4Name="new_entry_MathCourse_EachClass_GlobalCoverageCTA"
            >
              {btnName}
            </LeadButton>
          </div>
        </div>
        <div className="flex flex-col lg:flex-row lg:gap-[40px] xl:flex-row xl:gap-[60px]">
          <div className="hidden flex-1 flex-col justify-center rounded-[24px] bg-[#fff] shadow-[0_8px_30px_0_rgba(0,0,0,0.06)] lg:flex lg:shadow-[none] xl:flex xl:shadow-[none]">
            <h3 className="mb-[16px] text-[20px] font-bold leading-[24px] text-wk-words-1 lg:mb-[12px] lg:text-[20px] lg:leading-[28px] xl:mb-[16px] xl:text-[28px] xl:leading-[40px]">
              {t('math:数学建模')}
            </h3>
            <p
              className={cls(
                'mb-[16px] text-[16px] font-normal leading-[24px] text-wk-words-2 lg:mb-[20px] xl:mb-[40px] xl:text-[18px] xl:leading-[32px]',
                i18n?.language === 'zh' ? 'lg:leading-[28px]' : 'lg:leading-[22px]',
              )}
              dangerouslySetInnerHTML={{ __html: t('math:数学建模-副') }}
            />
            <LeadButton
              subject="math"
              theme="mathBorder"
              size="base"
              className="text-[16px] !font-[500] lg:h-[46px] lg:w-[144px] lg:px-[40px] lg:py-[12px] xl:h-[60px] xl:w-[200px] xl:px-[60px] xl:py-[16px] xl:!text-[20px]"
              traceName="O_MathCourse_EachClass_MathModelingCTAClick"
              traceGa4Name="new_entry_EachClass_MathModelingCTA"
            >
              {btnName}
            </LeadButton>
          </div>
          <div className="w-full overflow-hidden rounded-[24px] lg:h-[286px] lg:w-[440px] xl:h-[364px] xl:w-[560px]">
            <Image
              width={0}
              height={0}
              sizes="100vw"
              className="h-auto w-full"
              src={potentialImg2}
              alt={
                i18n.language === 'zh'
                  ? '真正掌握“数学建模”，点亮创造性思维'
                  : 'Mastering Modeling for Better Problem Solving'
              }
            />
          </div>
          <div className="mt-[-34px] flex flex-1 flex-col justify-center rounded-[24px] bg-[#fff] p-[24px] shadow-[0_8px_30px_0_rgba(0,0,0,0.06)] lg:mt-[0] lg:hidden lg:shadow-[none] xl:mt-[0] xl:hidden xl:shadow-[none]">
            <h3 className="mb-[16px] text-[20px] font-bold leading-[24px] text-wk-words-1 lg:mb-[12px] lg:text-[20px] lg:leading-[28px] xl:mb-[16px] xl:text-[28px] xl:leading-[40px]">
              {t('math:数学建模')}
            </h3>
            <p
              className={cls(
                'mb-[16px] text-[16px] font-normal leading-[24px] text-wk-words-2 lg:mb-[20px] xl:mb-[40px] xl:text-[18px] xl:leading-[32px]',
                i18n?.language === 'zh' ? 'lg:leading-[28px]' : 'lg:leading-[22px]',
              )}
              dangerouslySetInnerHTML={{ __html: t('math:数学建模-副') }}
            />
            <LeadButton
              subject="math"
              theme="mathBorder"
              size="base"
              className={cls(
                'm-auto h-[50px] w-[128px] text-[16px] !font-[500] lg:h-[46px] lg:w-[144px] lg:px-[40px] lg:py-[12px] xl:m-0 xl:h-[60px] xl:w-[200px] xl:px-[60px] xl:py-[16px] xl:!text-[20px]',
                i18n?.language === 'zh' ? 'w-[100px]' : 'w-[120px]',
              )}
              traceName="O_MathCourse_EachClass_MathModelingCTAClick"
              traceGa4Name="new_entry_EachClass_MathModelingCTA"
            >
              {btnName}
            </LeadButton>
          </div>
        </div>
        <div className="flex flex-col lg:flex-row lg:gap-[40px] xl:flex-row xl:gap-[60px]">
          <div className="w-full overflow-hidden rounded-[24px] lg:h-[286px] lg:w-[440px] xl:h-[364px] xl:w-[560px]">
            <Image
              width={0}
              height={0}
              sizes="100vw"
              className="h-auto w-full"
              src={potentialImg3}
              alt={
                i18n.language === 'zh'
                  ? '游戏化挑战设定，让兴趣成为最好的老师'
                  : 'We make math fun again through enjoyable, interactive classes.'
              }
            />
          </div>
          <div className="mt-[-34px] flex flex-1 flex-col justify-center rounded-[24px] bg-[#fff] p-[24px] shadow-[0_8px_30px_0_rgba(0,0,0,0.06)] lg:mt-[0] lg:p-0 lg:shadow-[none] xl:mt-[0] xl:p-0 xl:shadow-[none]">
            <h3 className="mb-[16px] text-[20px] font-bold leading-[24px] text-wk-words-1 lg:mb-[12px] lg:text-[20px] lg:leading-[28px] xl:mb-[16px] xl:text-[28px] xl:leading-[40px]">
              {t('math:游戏化挑战')}
            </h3>
            <p
              className={cls(
                'mb-[16px] text-[16px] font-normal leading-[24px] text-wk-words-2 lg:mb-[20px] xl:mb-[40px] xl:text-[18px] xl:leading-[32px]',
                i18n?.language === 'zh' ? 'lg:leading-[28px]' : 'lg:leading-[22px]',
              )}
              dangerouslySetInnerHTML={{ __html: t('math:游戏化挑战-副') }}
            />
            <LeadButton
              subject="math"
              theme="mathBorder"
              size="base"
              className="m-auto h-[50px] w-[128px] text-[16px] !font-[500] lg:m-0 lg:h-[46px] lg:w-[144px] lg:px-[40px] lg:py-[12px] xl:m-0 xl:h-[60px] xl:w-[200px] xl:px-[60px] xl:py-[16px] xl:!text-[20px]"
              traceName="O_MathCourse_EachClass_GamificationCTAClick"
              traceGa4Name="new_entry_EachClass_GamificationCTA"
            >
              {btnName}
            </LeadButton>
          </div>
        </div>
        <div className="flex flex-col lg:flex-row lg:gap-[40px] xl:flex-row xl:gap-[60px]">
          <div className="hidden flex-1 flex-col justify-center rounded-[24px] bg-[#fff] shadow-[0_8px_30px_0_rgba(0,0,0,0.06)] lg:flex lg:shadow-[none] xl:flex xl:shadow-[none]">
            <h3 className="mb-[16px] text-[20px] font-bold leading-[24px] text-wk-words-1 lg:mb-[12px] lg:text-[20px] lg:leading-[28px] xl:mb-[16px] xl:text-[28px] xl:leading-[40px]">
              {t('math:教育质量认证')}
            </h3>
            <p
              className={cls(
                'font-normal text-wk-words-2 lg:mb-[20px] xl:mb-[40px] xl:text-[18px] xl:leading-[32px]',
                i18n?.language === 'zh' ? 'lg:leading-[28px]' : 'lg:leading-[22px]',
              )}
              dangerouslySetInnerHTML={{ __html: t('math:教育质量认证-副') }}
            />
            {i18n?.language === 'zh' ? (
              <LeadButton
                onClick={() => {
                  window.open(
                    'https://www.wukongsch.com/blog/zh/cognia-certifies-wukong-education-highest-score-global-number-one-post-22206/',
                  );
                }}
                subject="math"
                theme="mathBorder"
                size="base"
                className="text-[16px] !font-[500] lg:h-[46px] lg:w-[144px] lg:px-[40px] lg:py-[12px] xl:h-[60px] xl:w-[200px] xl:px-[60px] xl:py-[16px] xl:!text-[20px]"
                traceName="O_MathCourse_EachClass_CogniaCTAClick"
                traceGa4Name="new_entry_EachClass_CogniaCTA"
              >
                {btnName}
              </LeadButton>
            ) : (
              <LeadButton
                subject="math"
                theme="mathBorder"
                size="base"
                className="text-[16px] !font-[500] lg:h-[46px] lg:w-[144px] lg:px-[40px] lg:py-[12px] xl:m-0 xl:h-[60px] xl:w-[200px] xl:px-[60px] xl:py-[16px] xl:!text-[20px]"
                traceName="O_MathCourse_EachClass_CogniaCTAClick"
                traceGa4Name="new_entry_EachClass_CogniaCTA"
              >
                {btnName}
              </LeadButton>
            )}
          </div>
          <div className="w-full overflow-hidden rounded-[24px] lg:h-[286px] lg:w-[440px] xl:h-[364px] xl:w-[560px]">
            <Image
              width={0}
              height={0}
              sizes="100vw"
              className="h-auto w-full"
              src={i18n?.language === 'zh' ? potentialImg4CN : potentialImg4EN}
              alt={i18n.language === 'zh' ? '获得国际教育质量认证“全球最高分”' : 'Accredited Internationally'}
            />
          </div>
          <div className="mt-[-34px] flex flex-1 flex-col justify-center rounded-[24px] bg-[#fff] p-[24px] shadow-[0_8px_30px_0_rgba(0,0,0,0.06)] lg:mt-[0] lg:hidden lg:shadow-[none] xl:mt-[0] xl:hidden xl:shadow-[none]">
            <h3 className="mb-[16px] text-[20px] font-bold leading-[24px] text-wk-words-1 lg:mb-[12px] lg:text-[20px] lg:leading-[28px] xl:mb-[16px] xl:text-[28px] xl:leading-[40px]">
              {t('math:教育质量认证')}
            </h3>
            <p
              className={cls(
                'mb-[16px] text-[16px] font-normal leading-[24px] text-wk-words-2 lg:mb-[20px] xl:mb-[40px] xl:text-[18px] xl:leading-[32px]',
                i18n?.language === 'zh' ? 'lg:leading-[28px]' : 'lg:leading-[22px]',
              )}
              dangerouslySetInnerHTML={{ __html: t('math:教育质量认证-副') }}
            />
            {i18n?.language === 'zh' ? (
              <LeadButton
                onClick={() => {
                  window.open(
                    'https://www.wukongsch.com/blog/zh/cognia-certifies-wukong-education-highest-score-global-number-one-post-22206/',
                  );
                }}
                subject="math"
                theme="mathBorder"
                size="base"
                className="m-auto h-[50px] w-[128px] text-[16px] !font-[500] lg:h-[46px] lg:w-[144px] lg:px-[40px] lg:py-[12px] xl:h-[60px] xl:w-[200px] xl:px-[60px] xl:py-[16px] xl:!text-[20px]"
                traceName="O_MathCourse_EachClass_CogniaCTAClick"
                traceGa4Name="new_entry_EachClass_CogniaCTA"
              >
                {btnName}
              </LeadButton>
            ) : (
              <LeadButton
                subject="math"
                theme="mathBorder"
                size="base"
                className="m-auto h-[44px] w-[120px] text-[16px] !font-[500] lg:h-[46px] lg:w-[144px] lg:px-[40px] lg:py-[12px] xl:h-[60px] xl:w-[200px] xl:px-[60px] xl:py-[16px] xl:!text-[20px]"
                traceName="O_MathCourse_EachClass_CogniaCTAClick"
                traceGa4Name="new_entry_EachClass_CogniaCTA"
              >
                {btnName}
              </LeadButton>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Potential;
